import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../lib/api';

export default function VerifyEmailPending() {
  const location = useLocation();
  const state = location.state as { email?: string; redirect?: string } | null;
  const email = state?.email ?? '';
  const redirect = state?.redirect ?? null;
  // Surface redirect hint so user knows where they'll end up after verification
  const isInvite = redirect?.includes('accept-invite');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function resend() {
    if (!email || loading) return;
    setLoading(true);
    try {
      await api.post('/auth/resend-verification', { email });
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#f4f4f4' }}>
      <div className="w-full max-w-md text-center">

        {/* Icon */}
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: '#fff0f0', border: '2px solid #fca5a5' }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e00000" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
        </div>

        <h1 className="text-2xl font-bold mb-2" style={{ color: '#0b0d0e' }}>Check your email</h1>
        <p className="text-sm mb-4" style={{ color: '#8f9b9b', lineHeight: 1.7 }}>
          We've sent a verification link to{' '}
          {email ? <strong style={{ color: '#374151' }}>{email}</strong> : 'your email address'}.
          {' '}Click the link to activate your account.
        </p>
        {isInvite && (
          <div className="mb-4 px-4 py-3 rounded-lg flex items-center gap-2 text-sm text-left" style={{ background: '#fff', border: '1px solid #e5e5e5', color: '#374151' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e00000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            After verifying, you'll be taken back to accept your company invitation.
          </div>
        )}

        <div className="card text-left mb-4" style={{ fontSize: 13, color: '#374151' }}>
          <p className="font-semibold mb-2" style={{ color: '#0b0d0e' }}>Didn't receive it?</p>
          <ul style={{ paddingLeft: 16, lineHeight: 2 }}>
            <li>Check your spam or junk folder</li>
            <li>Make sure you typed the right email</li>
            <li>The link expires after 24 hours</li>
          </ul>
        </div>

        {sent ? (
          <p className="alert-success mb-4">Verification email resent!</p>
        ) : (
          <button
            onClick={resend}
            disabled={!email || loading}
            className="btn-primary w-full mb-3"
          >
            {loading ? 'Sending…' : 'Resend verification email'}
          </button>
        )}

        <p className="text-sm" style={{ color: '#8f9b9b' }}>
          Already verified?{' '}
          <Link to={`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} style={{ color: '#e00000', fontWeight: 600 }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
